import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { customerShareIndicadores } from '../../../../home/pic/customer-share/indicador/customer-share-indicador';

@Component({
  selector: 'sgt-novo-customer-share-indicador-multiselect',
  templateUrl: './novo-customer-share-indicador-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoCustomerShareIndicadorMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoCustomerShareIndicadorMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() indicadores: number[];
  @Output() indicadoresChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione os indicadores',
    singular: 'Indicador',
    plural: 'Indicadores',
    searchEmptyResultMessage: 'Nenhum indicador encontrado',
    isDisabled: false,
    isLoading: false,
    emitAfterClosed: false,
    showFooter: false
  };

  options: IOption[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.create();
  }

  private create() {
    this.options = customerShareIndicadores.map((indicador) => ({
      id: indicador.id,
      label: indicador.nome
    }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.indicadores = newValue;
  }

  onSearch() {
    this.indicadoresChange.emit(this.indicadores);
  }

  onSelectionChange() {
    this.emitChange(this.indicadores);
    this.markAsTouched();
  }
}
